import { LUCKY_EVENTS, LUCKY_DATA_SOURCE } from '@/packages/components/hook/useLucky'

/**
 * 组件信息
 */
export const info = {
  name: 'xy-lucky-wheel', // 组件名
  type: 'component-business', // 组件类型
  label: '幸运转盘1', // 组件label
  icon: 'icon-xy-lucky-wheel', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 750 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  width: { type: Number, default: 300 }, // 转盘宽度
  blocksSrc: { type: String, default: '' }, // 转盘图片
  buttonsSrc: { type: String, default: '' }, // 按钮图片
  buttonsRadius: { type: Number, default: 100 }, // 按钮半径
  indicatorSrc: { type: String, default: '' }, // 指引效果图片
  offsetDegree: { type: Number, default: 0 }, // 偏移角度
  speed: { type: Number, default: 20 }, // 旋转速度
  accelerationTime: { type: Number, default: 1500 }, // 开始旋转事件
  decelerationTime: { type: Number, default: 1500 }, // 缓慢停止时间
  activityId: { type: String, default: '' }, // 活动id
  prizes: { type: Array, default: [] }, // 奖品列表
  prizeImages: { type: Object, default: {} }, // 奖品图片
  checkBoxTop: { type: Number, default: 10 }, // 复选框距离顶部距离
  checkBoxColor: { type: String, default: '#beabec' }, // 复选框颜色
  checkBoxSrc: { type: String, default: '' }, // 勾选框图片
  checkBoxSelectSrc: { type: String, default: '' }, // 勾选框选中图片
  dialogUUID: { type: String, default: '' } // 弹窗uuid
}

/**
 * 组件开放方法事件
 */
export const events = LUCKY_EVENTS

/**
 * 组件开放数据源
 */
export const dataSource = LUCKY_DATA_SOURCE

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-lucky-wheel' // 表单组件
  }
]
